module.exports = __webpack_public_path__ + "img/5.57727306.jpg";